/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthGetUrlUpdateLineResponse } from "./AuthGetUrlUpdateLineResponse";

export type AuthGetUrlUpdateLineResponseApiRespoonse = {
  data?: AuthGetUrlUpdateLineResponse;
  status?: AuthGetUrlUpdateLineResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthGetUrlUpdateLineResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
